import React from 'react';
import { SliderSC } from './slider.styled';
import RcSlider, { SliderProps } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { SliderRef } from 'rc-slider/lib/Slider';
import classNames from 'classnames';

interface RCSliderProps extends Omit<SliderProps, 'vertical'> {
  className?: string;
  style?: React.CSSProperties;
}

const Slider = (
  {
    className,
    style,
    // @ts-expect-error remove from props
    vertical,
    ...rest
  }: RCSliderProps,
  ref?: React.Ref<SliderRef>,
) => {
  return (
    <SliderSC className={classNames('ui-slider', className)} style={style}>
      <RcSlider ref={ref} {...rest} />
    </SliderSC>
  );
};

export default React.forwardRef(Slider);
